package devxertech.com.pages.blogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlass
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonDropdown
import devxertech.com.component.PaginationNumberComponent
import devxertech.com.models.BlogsData
import devxertech.com.pages.commons.OptionalInputIconField
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun BlogsDescription() {
    val breakpoint = rememberBreakpoint()
    val palette = ColorMode.current.toSitePalette()

    var searchText by remember { mutableStateOf("") }
    var selectedBlogs by remember { mutableStateOf("Select Category") }
    var currentPage by remember { mutableStateOf(1) }


    val blogData = remember {
        mutableStateListOf(
            BlogsData(
                image = Res.Image.blog_1,
                date = "January 29, 2025",
                title = "DeepSeek-R1: The Disruptive Force Reshaping the AI Sector",
                description = "Discover how DeepSeek-R1 is redefining the future of artificial intelligence.",
                category = "AI",
                link = "/blog-Page"
            ),
            BlogsData(
                image = Res.Image.blog_6,
                date = "February 10, 2025",
                title = "Quantum-AI: The Next Leap in Computing",
                description = "Quantum-AI hybrid models are setting a new pace for data-driven breakthroughs.",
                category = "Machine Learning"
            ),
            BlogsData(
                image = Res.Image.blog_5,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Robotics"
            ),
            BlogsData(
                image = Res.Image.blog_4,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Data"
            ),
            BlogsData(
                image = Res.Image.blog_5,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "AI"
            ),
            BlogsData(
                image = Res.Image.blog_6,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Machine Learning"
            ),
            BlogsData(
                image = Res.Image.blog_4,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Robotics"
            ),
            BlogsData(
                image = Res.Image.blog_5,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Data"
            ),
            BlogsData(
                image = Res.Image.blog_1,
                date = "January 29, 2025",
                title = "DeepSeek-R1: The Disruptive Force Reshaping the AI Sector",
                description = "Discover how DeepSeek-R1 is redefining the future of artificial intelligence.",
                category = "AI"
            ),
            BlogsData(
                image = Res.Image.blog_2,
                date = "February 10, 2025",
                title = "Quantum-AI: The Next Leap in Computing",
                description = "Quantum-AI hybrid models are setting a new pace for data-driven breakthroughs.",
                category = "Machine Learning"
            ),
            BlogsData(
                image = Res.Image.blog_3,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Robotics"
            ),
            BlogsData(
                image = Res.Image.blog_6,
                date = "March 5, 2025",
                title = "AI in Robotics: Building Smarter Machines",
                description = "Robotic automation and adaptive AI are reshaping the global workforce.",
                category = "Data"
            )
        )
    }

    fun resetPage() {
        currentPage = 1
    }

    val filteredBlogs = blogData.filter { blog ->
        val matchesTitle =
            searchText.isBlank() || blog.title.contains(searchText, ignoreCase = true)
        val matchesCategory = selectedBlogs == "Select Category" || blog.category.equals(
            selectedBlogs,
            ignoreCase = true
        )
        matchesTitle && matchesCategory
    }

// --- Pagination ---
    val rowsPerPage = 6
    val totalPages = (filteredBlogs.size + rowsPerPage - 1) / rowsPerPage
    if (currentPage > totalPages) currentPage = 1

    val startIndex = ((currentPage - 1) * rowsPerPage).coerceAtMost(filteredBlogs.size)
    val endIndex = (startIndex + rowsPerPage).coerceAtMost(filteredBlogs.size)
    val paginatedBlogs = filteredBlogs.subList(startIndex, endIndex)

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG) 5.percent else if (breakpoint < Breakpoint.MD) 8.percent else 15.percent)
            .margin(top = 50.px, bottom = 30.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(50.px)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .gap(if (breakpoint < Breakpoint.MD) 30.px else 0.px)
                .flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            OptionalInputIconField(
                width = when {
                    breakpoint < Breakpoint.MD -> 100.percent
                    breakpoint == Breakpoint.MD -> 35.percent
                    window.screen.width in 900..1440 -> 25.percent
                    else -> 16.percent
                },

                value = searchText,
                onValueChange = {
                    searchText = it
                    resetPage()
                },
                inputType = InputType.Text,
                placeHolder = "Search for Blogs...",
                trailingIcon = {
                    FaMagnifyingGlass(
                        size = IconSize.SM,
                        modifier = Modifier.color(
                            palette.textFieldTextColor.rgb.copyf(alpha = 0.6f)
                        )
                    )
                },
            )

            CommonDropdown(
                data = listOf("Select Category", "AI", "Machine Learning", "Data", "Robotics"),
                width = when {
                    breakpoint < Breakpoint.MD -> 100.percent
                    breakpoint == Breakpoint.MD -> 35.percent
                    window.screen.width in 900..1440 -> 25.percent
                    else -> 16.percent
                },

                selectedItem = selectedBlogs,
                listWidth = 100.percent,
                onSelect = {
                    selectedBlogs = it
                    resetPage()
                }
            )
        }

        // Row 1
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .gap(20.px)
                .flexWrap(FlexWrap.Wrap),
            horizontalArrangement = if (searchText.isBlank() && selectedBlogs == "Select Category") {
                Arrangement.SpaceBetween
            } else {
                Arrangement.Start
            },
            verticalAlignment = Alignment.CenterVertically
        ) {
            paginatedBlogs.forEach { data ->
                CommonInfoCard(
                    imageUrl = data.image,
                    date = data.date,
                    title = data.title,
                    description = "",
                    linkText = "Read More",
                    linkUrl = data.link
                )
            }
        }

        Row(
            modifier = Modifier.fillMaxWidth().margin(top = (-30).px),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {

            PaginationNumberComponent(
                id = "userPagination",
                width = 100.percent,
                currentPage = currentPage,
                totalPages = (filteredBlogs.size + rowsPerPage - 1) / rowsPerPage,
                onPageChange = { newPage -> currentPage = newPage },
                sitePalette = palette
            )
        }
    }
}

